export default __webpack_public_path__ + "images/0x580a84c73811e1839f75d86d75d88cca0c241ff4.png";